//React
import React from 'react';

function Signup() {
  return (
    <div>
      <h1>Signup Page</h1>
    </div>
  );
}

export default Signup;
